// extracted by mini-css-extract-plugin
module.exports = {"textSecondary":"undefined","section":"Section-module--section--VDhYk","title":"Section-module--title--2LGE3","sectionTitle":"Section-module--sectionTitle--2GO0s"};